import {AddToArrayParams} from 'interfaces'

export const isEmptyDataType = (value: unknown) => {
  if (!value) {
    return true
  }
  // Check for data-types.
  if (typeof value === 'string') {
    return value.trim() === ''
  } else if (Array.isArray(value)) {
    return value.length === 0
  } else if (value !== null && typeof value === 'object') {
    return Object.keys(value).length === 0
  }
  return false
}

export const removeEmptyKeysFromObjects = (obj?: object): object => {
  if (!obj) {
    return {}
  }
  return Object.fromEntries(
    Object.entries(obj).filter(([_key, value]) => !isEmptyDataType(value)),
  )
}

/**
 *
 * @param list The list to add elements to.
 * @param startIndex The index to start adding elements.
 * @param elements The elements to add to the list at the startIndex.
 * @returns A new array with the elements inserted at the specified index.
 */
export const addToArray = <T>({
  list,
  startIndex,
  elements,
}: AddToArrayParams<T>): T[] => {
  const newList = [...list]
  newList.splice(startIndex, 0, ...elements)
  return newList
}

export const omitKeyFromObject = <T extends object, K extends keyof T>(
  obj: T = {} as T,
  keyToOmit: K,
): Omit<T, K> => {
  const {[keyToOmit]: _, ...rest} = obj
  return rest
}

export const omitKeysFromObject = <T extends object, K extends keyof T>(
  obj: T = {} as T,
  keysToOmit: K[],
): Omit<T, K> => {
  const result = {...obj}
  for (const key of keysToOmit) {
    delete result[key]
  }
  return result as Omit<T, K>
}
